// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import cn from 'classnames';
import {Proxy_type, t_generated_proxy, t_order}
from '../../../../hola/pub/ui/pro/cp/orders';
import {date_fmt, get_usage_info, use_expired_orders} from './utils';
import {t_countries} from '../../lib/use_dashboard_data';
import {Action_menu} from './action_menu/action_menu';
import Icon_refresh from '../../img/icons/refresh.svg';
import {useHistory} from 'react-router-dom';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import {Flag} from '../../../../hola/pub/lib/flag';
import {Pie_chart} from '../toolip/pie_chart';
import {Table_header} from './plan_table';

import styles from './plan_table.module.less';

interface i_table_plan_history_props {
    type: Proxy_type;
    items?: t_order[];
    title: string | React.ReactNode;
    countries?: t_countries;
    wrapper_cn: string
    show_order_token?: boolean
    hide_recently_expired?: boolean;
    plan_popup_actions?: (item: t_order) => React.ReactNode
    render_bandwidth_info?: (item: t_order) => React.ReactNode
    render_usage_info?: (item: t_order) => React.ReactNode
}

export const Plan_history_table = (props:i_table_plan_history_props)=>{
    const {items, type, title, hide_recently_expired} = props;
    const visible_orders = use_expired_orders(items, hide_recently_expired);
    const history = useHistory();
    if (visible_orders.length===0)
      return null;
    const on_buy_again = (item: t_order)=>
      history.push(`/pricing/checkout?plan_id=${item.plan_id}`);
    return <div className={cn(styles.table_wrapper, props.wrapper_cn)}>
      <Table_header title={title}
        buttons={[]} />
      <table className={cn(styles.plan_table, styles.table_history)}>
        <thead>
          <tr>
            <th>Qty</th>
            <th>Creation Date</th>
            <th>Expiration Date</th>
            <th>Bandwidth (GB)</th>
            <th>Configured proxies</th>
            {props.show_order_token && <th>Order token</th>}
            <th className={styles.table_actions}></th>
          </tr>
        </thead>
        <tbody>
          {visible_orders?.map(item=>{
            const usage = get_usage_info(item);
            const first_col = item.unit=='ip'
                ? `${item.ips_amount} prox${item.ips_amount > 1 ? 'ies':'y'}`
                : usage.limit_label;
            return <tr key={item._id}>
              <td>{first_col}</td>
              <td>{date_fmt(item.start)}</td>
              <td>{date_fmt(item.subscription_until)}</td>
              <td className={styles.table_data_usage}>
                {props.render_bandwidth_info?.(item) ??
                <Bandwidth_info type={type} order={item} />}
              </td>
              <td>
                {props.render_usage_info?.(item) ??
                <Proxies_usage_info order={item} />}</td>
              {props.show_order_token && <td>{item.client_id}</td>}
              <td className={styles.table_actions}>
                <div className={styles.table_actions_block}>
                  {props.plan_popup_actions
                    ? props.plan_popup_actions(item)
                    : !item.free_zone && <Action_menu position={'left'}
                      cls={styles.dots_history}
                      items={[{id: 'buy_again', text: 'Buy again',
                        icon: Icon_refresh,
                        on_click: ()=>on_buy_again(item)}]} />}
                </div>
              </td>
            </tr>;
          })}
        </tbody>
    </table>
  </div>;
};

interface i_bandwidth_info_props {
    type: Proxy_type;
    order: t_order;
}

const Bandwidth_info = ({order, type}:i_bandwidth_info_props)=>{
    const usage = get_usage_info(order);
    if (type == 'isp_plus' || type == 'isp')
    {
        if (order.free_zone)
            return <span>100MB</span>;
        return <span className={styles.tooltip}
          data-tt="Need more Bandwidth? No problem.
          When we say Unlimited, we mean it. On the house!">
          unlimited</span>;
    }

    return <span className={cn(styles.tooltip, styles.bandwidth_info)}
      data-tt={`${usage.used_label} out of ${usage.limit_label}`}>
      <Pie_chart percentage={usage.percent_number} />
      {usage.percent}
    </span>;
};

const Proxies_usage_info = ({order}:{order: t_order})=>{
    if (order.unit == 'gb')
      return <>unlimited</>;
    const proxies = order.generated_proxies?.
        filter(p=>order.type != 'dedicated_dc' || p.manually_changed) ?? [];
    const usage_percent = `${proxies.length*100/order.ips_amount}%`;
    return <span className={cn(styles.ips_tooltip)}>
      <Proxies_countries_tooltip proxies={proxies} />
      <span className={styles.progressbar}>
        <span className={styles.progressbar_res}
          style={{width: usage_percent}} />
      </span>
      {`${proxies.length}/${order.ips_amount}`}</span>;
};

const Proxies_countries_tooltip = ({proxies}:
  {proxies?: t_generated_proxy[]})=>{
    if (!proxies || proxies.length == 0)
        return <></>;

    const dict = proxies.reduce((a, c)=>{
      a[c.country] = (a[c.country] ?? 0) + 1;
      return a;
    }, {});

    return <span className={styles.ips_tooltip_container}>
      <span className={styles.ips_tooltip__header}>Qty</span>
      <span className={styles.ips_tooltip__header}>Country</span>
      {Object.entries(dict).map(([country, count])=>{
        return <Fragment key={country}>
          <span>{count as number}</span>
          <span><Flag country={country} size={16} round />
            {get_country_object(country)?.name}</span>
        </Fragment>;
      })}
    </span>;
};
